import { useTranslation } from "@/hooks/useTranslation";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import type { Language } from "@/contexts/LanguageContext";

export const LanguageSwitcher = () => {
  const { language, setLanguage, t } = useTranslation();

  const handleLanguageChange = (value: string) => {
    setLanguage(value as Language);
  };

  return (
    <div className="space-y-4">
      <div>
        <h3 className="text-lg font-semibold mb-2">{t('settings.language')}</h3>
        <p className="text-sm text-muted-foreground mb-4">
          Choose your preferred language
        </p>
      </div>
      
      <RadioGroup value={language} onValueChange={handleLanguageChange}>
        <div className="flex items-center space-x-2 p-3 rounded-lg border hover:bg-accent cursor-pointer">
          <RadioGroupItem value="en" id="lang-en" />
          <Label htmlFor="lang-en" className="flex-1 cursor-pointer">
            <div className="font-medium">English</div>
            <div className="text-sm text-muted-foreground">English</div>
          </Label>
        </div>
        
        <div className="flex items-center space-x-2 p-3 rounded-lg border hover:bg-accent cursor-pointer">
          <RadioGroupItem value="cs" id="lang-cs" />
          <Label htmlFor="lang-cs" className="flex-1 cursor-pointer">
            <div className="font-medium">Čeština</div>
            <div className="text-sm text-muted-foreground">Czech</div>
          </Label>
        </div>
      </RadioGroup>
    </div>
  );
};
